import { FormContextValues } from '@dreryk/react-common';
import { FormController } from '@dreryk/react-components';

const EWUS_ENABLED_FIELD_NAME = 'ewusEnabled';

export type EwusEnabledFormBeanPart<VALUE extends boolean = boolean> = {
   [EWUS_ENABLED_FIELD_NAME]: VALUE;
};

type EwusEnabledFieldProps = Pick<FormContextValues<EwusEnabledFormBeanPart>, 'register'>;

export const EwusEnabledField = (props: EwusEnabledFieldProps): JSX.Element => {
   const controller = props.register(EWUS_ENABLED_FIELD_NAME);

   return <FormController controller={controller} />;
};
